import React, { useContext } from 'react';
import cn from 'class-names';
import { ThemeContext, getLocalThemeClassName, getComponentOverrideClassName } from './ThemeContext';

/**
 * @template {Record<string, any> & {displayName?: string} } P
 * @param {React.FC<P>} Component
 * @returns {React.FC<P>}
 */
const withTheme =
  (Component) =>
  /**
   * @param {{ children?: any; displayName?: string; }} param0
   * @returns {JSX.Element}
   */
  ({ children, displayName, ...props }) => {
    const componentName = displayName || Component.displayName;
    const theme = useContext(ThemeContext);
    return (
      <div className={cn(getLocalThemeClassName(theme))} style={{ height: 'inherit' }}>
        <div className={componentName && getComponentOverrideClassName(componentName, theme)} style={{ height: 'inherit' }}>
          <Component {...props} theme={theme} colorScheme={theme.colorScheme}>
            {children}
          </Component>
        </div>
      </div>
    );
  };

export default withTheme;
